<template>
  <section class="hosting-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-9">
          <div class="hosting-card" v-reveal v-tilt="3">
            <div class="hosting-icon">
              <i class="fas fa-server"></i>
            </div>
            <span class="section-label">{{ $t('hosting.label') }}</span>
            <h2 class="section-title">{{ $t('hosting.title') }}</h2>
            <p class="hosting-text">{{ $t('hosting.text') }}</p>
            <a
              class="btn-hosting"
              href="https://www.quixor.nl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('hosting.cta') }} <i class="fas fa-external-link-alt"></i>
            </a>
            <p class="hosting-note">{{ $t('hosting.note') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HostingComponent",
}
</script>

<style scoped>
/* Feathered dark veil, same rhythm language as the other panels. */
.hosting-section {
  padding: 6rem 0 5rem;
  background: linear-gradient(180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.55) 18%,
    rgba(0, 0, 0, 0.55) 82%,
    rgba(0, 0, 0, 0) 100%);
}

.hosting-card {
  background: linear-gradient(160deg, #151515, #0e0e0e);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  padding: 3.5rem 3rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 14px 44px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transform-style: preserve-3d;
}

/* amber accent line on top */
.hosting-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--accent-grad);
}

.hosting-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: var(--accent-tint);
  border: 1px solid var(--accent-line);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--accent);
  margin: 0 auto 1.5rem;
  box-shadow: 0 0 28px var(--accent-tint);
}

.section-label {
  display: inline-block;
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 0.8rem;
  color: var(--accent);
  letter-spacing: 1px;
  margin-bottom: 0.875rem;
}

.section-title {
  font-family: 'Jersey 15', sans-serif;
  font-size: 2.75rem;
  color: var(--text);
  font-weight: 400;
  margin-bottom: 1.25rem;
  letter-spacing: 0;
}

.hosting-text {
  color: var(--text-muted);
  font-size: 1.05rem;
  line-height: 1.85;
  max-width: 640px;
  margin: 0 auto 2.25rem;
}

.btn-hosting {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: var(--accent-grad);
  color: #0a0a0a;
  padding: 0.9rem 2.1rem;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
  transition: filter 0.2s, transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 6px 30px var(--accent-glow);
}

.btn-hosting:hover {
  filter: brightness(1.06);
  color: #0a0a0a;
  transform: translateY(-2px);
  box-shadow: 0 10px 40px var(--accent-glow);
  text-decoration: none;
}

.btn-hosting i {
  font-size: 0.8rem;
  transition: transform 0.2s;
}

.btn-hosting:hover i {
  transform: translate(2px, -2px);
}

.hosting-note {
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 0.75rem;
  color: var(--text-dim);
  letter-spacing: 0.5px;
  margin: 1.5rem 0 0;
}

@media (max-width: 991px) {
  .hosting-section { padding: 5rem 0 4rem; }
}

@media (max-width: 767px) {
  .hosting-section { padding: 4rem 0 3rem; }
  .hosting-card { padding: 2.5rem 1.5rem; }
  .section-title { font-size: 1.875rem; }
  .hosting-text { font-size: 0.95rem; }
}
</style>
